import React from 'react';
import './App.scss';
import Sidebar from './components/common/sidebar/sidebar';
import Topbar from './components/common/topbar/topbar';
import Differentiator from './components/pages/differentiator/differentiator';
import Backup from './components/pages/backup/backup';
import {
  BrowserRouter as Router,
  Switch,
  Route,

} from "react-router-dom";
function App () {
  return (
    <Router>
      <div className="App">
        <div className="App__topbar">
          <Topbar />
        </div>
        {/* <Sidebar /> */}
        <div className="App__content">
          <Switch>

            <Route exact path="/">
              <Differentiator />
            </Route>

            {/* <Route exact path="/bkp">
              <Backup />
            </Route> */}

          </Switch>
        </div>
      </div>
    </Router>
  );
}

export default App;
